<template>
  <a-row :gutter="20" class="pl-5 pr-5 pt-5 pb-5 container m-auto">
    <a-col :span="isDesktop ? 12 : 24" class="float-none m-auto" v-if="isReady">
      <a-card :title="$t('cardTitle.updateBillingInfo')" class="style3 updateBillingInfo">
        <a-form :form="form" :layout="'vertical'" @submit="handleSubmit" id="billingInfo">
          <a-form-item :label="$t('label.firstNameFirstHalfChurchName')">
            <a-input data-recurly="first_name" v-decorator="['first_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputFirstName') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.lastNameSecondHalfChurchName')">
            <a-input data-recurly="last_name" v-decorator="['last_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputLastName') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.cardNumber')">
            <a-input @keypress.native="isNumber($event)" data-recurly="number" v-decorator="['number', { rules: [{ required: true, message: $t('placeholder.pleaseInputCardNumber') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.expirationDate')" style="margin: 0;">
            <a-form-item :style="{ display: 'inline-block', width: '150px' }">
              <a-input @keypress.native="isNumber($event)" :maxLength="2" data-recurly="month" v-decorator="['month', { rules: [{ required: true, message: $t('placeholder.pleaseInputMonth') }] }]" />
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">/</span>
            <a-form-item :style="{ display: 'inline-block', width: '150px' }">
              <a-input @keypress.native="isNumber($event)" :maxLength="2" data-recurly="year" v-decorator="['year', { rules: [{ required: true, message: $t('placeholder.pleaseInputYear') }] }]" />
            </a-form-item>
          </a-form-item>
          <a-form-item :label="$t('label.CVV')" :style="{ width: '150px' }">
            <a-input @keypress.native="isNumber($event)" data-recurly="cvv" :maxLength="3" v-decorator="['cvv', { rules: [{ required: true, message: $t('placeholder.pleaseInputCVV') }] }]" />
          </a-form-item>
          <input type="hidden" data-recurly="token" name="recurly_code" id="recurlyCode" />
          <a-form-item :wrapper-col="{ span: 12, offset: 0 }">
            <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('button.reset') }}</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { mapState } from 'vuex';
import BillingService from '@/services/BillingService';
import initRecurly from '@/services/Recurly';
import { get, isEmpty } from 'lodash';
import jwtDecode from 'jwt-decode';
export default {
  data: () => ({
    isLoading: false,
    isReady: false,
    reset_code: null,
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'billingInfo' });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async mounted() {
    const { billingtoken } = this.$route.query;
    try {
      // eslint-disable-next-line camelcase
      const { recurly_code } = jwtDecode(billingtoken);
      if (isEmpty(billingtoken) || isEmpty(recurly_code)) {
        throw new Error('token invalid');
      }
      // eslint-disable-next-line camelcase
      this.reset_code = recurly_code;
      await initRecurly();
      this.isReady = true;
    } catch (ex) {
      this.$error({
        title: 'Error',
        content: 'Billing token invalid',
        class: 'no-button',
        centered: true,
      });
    }
  },
  methods: {
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billingInfo'), err => {
          if (!isEmpty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await this.checkoutRecurly();
            await BillingService.doBillingReset({
              recurly_token: document.getElementById('recurlyCode').value,
              reset_code: this.reset_code,
            });
            this.$notification['success']({
              message: 'Reset successful.',
              description: `Credit Card Saved`,
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: get(error, 'response.status', error.code),
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.no-button {
  .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {
    display: none;
  }
}
</style>
